import {Component} from '@angular/core';
import { DataStoreService } from 'app/shared/data-store/services/data-store.service';

@Component({
  selector: 'thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.css'],
})
export class ThanksComponent {

  private lang: string;
  constructor(private dataStoreService: DataStoreService) {}

  ngOnInit() {
    this.lang = this.dataStoreService.lang;
 }

 public langSafe(de: string, en: string, linebreak: boolean = false): string {
  if (this.lang == 'de' ) {
    return de.replace(/''/g, '"');
  }
  if (this.lang == 'en' ) {
    return en.replace(/''/g, '"');
  }
  return (de + ' / ' + (linebreak ? '<br/>' : '') + en).replace(/''/g, '"');
 }

}
